import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

export const SelectChevronIcon = ({ className }) => <FontAwesomeIcon icon={faChevronDown} className={className} />;

SelectChevronIcon.propTypes = {
  className: PropTypes.string,
};

SelectChevronIcon.defaultProps = {
  className: '',
};

export const PULSE_V2_NEUTRAL_SURFACE_BG = 'secondary.main';

export const WHITE_PILL_SEGMENTED_TOGGLE_SX = {
  border: 0,
  borderRadius: 0,
  backgroundColor: 'transparent',
  p: 0,
  gap: 0.35,
  '& .MuiToggleButton-root': {
    border: 0,
    borderRadius: '10px',
    px: 1.1,
    py: 0.33,
    fontSize: '0.9rem',
    lineHeight: 1.2,
    fontWeight: 400,
    textTransform: 'none',
    color: '#64748b',
    minHeight: 30,
    backgroundColor: 'transparent',
    transition: 'background-color 120ms ease, color 120ms ease',
  },
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  '& .MuiToggleButton-root.Mui-selected': {
    backgroundColor: PULSE_V2_NEUTRAL_SURFACE_BG,
    color: '#0f172a',
    fontWeight: 600,
    border: 0,
    boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)',
  },
  '& .MuiToggleButton-root.Mui-selected:hover': {
    backgroundColor: PULSE_V2_NEUTRAL_SURFACE_BG,
    border: 0,
  },
  '& .MuiToggleButton-root.Mui-focusVisible': {
    boxShadow: '0 0 0 2px rgba(52, 97, 137, 0.26)',
  },
  '& .MuiToggleButton-root:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
};

export const BORDERLESS_SELECT_SX = {
  '& .MuiInputBase-root': {
    alignItems: 'center',
    minWidth: 0,
  },
  '& .MuiInput-root': {
    '&:before': {
      display: 'none',
    },
    '&:after': {
      display: 'none',
    },
    '&:hover:not(.Mui-disabled):before': {
      display: 'none',
    },
  },
  '& .MuiSelect-select': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: '30px !important',
    color: '#334155',
    fontSize: '0.9rem',
    fontWeight: 400,
    lineHeight: 1.2,
    display: 'block',
    minHeight: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent',
  },
  '& .MuiSelect-select.Mui-focused': {
    backgroundColor: 'transparent',
  },
  '& .MuiInputBase-root.Mui-focused .MuiSelect-select': {
    backgroundColor: 'transparent',
  },
  '& .MuiSelect-icon': {
    right: 0,
    color: '#7b889b',
    fontSize: '1rem',
    top: '50%',
    transform: 'translateY(-50%)',
  },
};
